var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.workloadColor + '--text'},[_vm._v(" "+_vm._s(_vm.onWaitingList)+" / "+_vm._s(_vm.capacityUsed)+" / "+_vm._s(_vm.capacity)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }